import { useCallback, useEffect, useState } from "react";

export type Ao3Theme = "light" | "dark";

const AO3_THEME_KEY = "ao3-theme";

function readStoredTheme(): Ao3Theme {
  try {
    const stored = localStorage.getItem(AO3_THEME_KEY);
    if (stored === "dark" || stored === "light") return stored;
  } catch {
    /* ignore */
  }
  return "light";
}

export function useAo3Theme() {
  const [theme, setTheme] = useState<Ao3Theme>(readStoredTheme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    root.style.colorScheme = theme;
    try {
      localStorage.setItem(AO3_THEME_KEY, theme);
    } catch {
      /* ignore */
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  }, []);

  return { theme, toggleTheme };
}